/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkCreateOrUpdateUserconfigurationDto } from '../models/work-create-or-update-userconfiguration-dto';
import { WorkUserconfiguration } from '../models/work-userconfiguration';

@Injectable({ providedIn: 'root' })
export class WorkUserconfigurationsV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `userconfigurationsV2ControllerGetMyUserconfigurations()` */
  static readonly UserconfigurationsV2ControllerGetMyUserconfigurationsPath = '/v2/userconfigurations';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userconfigurationsV2ControllerGetMyUserconfigurations()` instead.
   *
   * This method doesn't expect any request body.
   */
  userconfigurationsV2ControllerGetMyUserconfigurations$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkUserconfiguration>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkUserconfigurationsV2Service.UserconfigurationsV2ControllerGetMyUserconfigurationsPath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkUserconfiguration>>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userconfigurationsV2ControllerGetMyUserconfigurations$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userconfigurationsV2ControllerGetMyUserconfigurations(
    params?: {
    },
    context?: HttpContext
  ): Observable<Array<WorkUserconfiguration>> {
    return this.userconfigurationsV2ControllerGetMyUserconfigurations$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkUserconfiguration>>): Array<WorkUserconfiguration> => r.body)
    );
  }

  /** Path part for operation `userconfigurationsV2ControllerCreateOrUpdate()` */
  static readonly UserconfigurationsV2ControllerCreateOrUpdatePath = '/v2/userconfigurations';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userconfigurationsV2ControllerCreateOrUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userconfigurationsV2ControllerCreateOrUpdate$Response(
    params: {
      body: WorkCreateOrUpdateUserconfigurationDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkUserconfiguration>> {
    const rb = new RequestBuilder(this.rootUrl, WorkUserconfigurationsV2Service.UserconfigurationsV2ControllerCreateOrUpdatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkUserconfiguration>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userconfigurationsV2ControllerCreateOrUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userconfigurationsV2ControllerCreateOrUpdate(
    params: {
      body: WorkCreateOrUpdateUserconfigurationDto
    },
    context?: HttpContext
  ): Observable<WorkUserconfiguration> {
    return this.userconfigurationsV2ControllerCreateOrUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkUserconfiguration>): WorkUserconfiguration => r.body)
    );
  }

  /** Path part for operation `userconfigurationsV2ControllerGetMyUseronfigurationByKey()` */
  static readonly UserconfigurationsV2ControllerGetMyUseronfigurationByKeyPath = '/v2/userconfigurations/byConfigurationKey/{configurationKey}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userconfigurationsV2ControllerGetMyUseronfigurationByKey()` instead.
   *
   * This method doesn't expect any request body.
   */
  userconfigurationsV2ControllerGetMyUseronfigurationByKey$Response(
    params: {
      configurationKey: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkUserconfiguration>> {
    const rb = new RequestBuilder(this.rootUrl, WorkUserconfigurationsV2Service.UserconfigurationsV2ControllerGetMyUseronfigurationByKeyPath, 'get');
    if (params) {
      rb.path('configurationKey', params.configurationKey, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkUserconfiguration>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userconfigurationsV2ControllerGetMyUseronfigurationByKey$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userconfigurationsV2ControllerGetMyUseronfigurationByKey(
    params: {
      configurationKey: string;
    },
    context?: HttpContext
  ): Observable<WorkUserconfiguration> {
    return this.userconfigurationsV2ControllerGetMyUseronfigurationByKey$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkUserconfiguration>): WorkUserconfiguration => r.body)
    );
  }

  /** Path part for operation `userconfigurationsV2ControllerDelete()` */
  static readonly UserconfigurationsV2ControllerDeletePath = '/v2/userconfigurations/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userconfigurationsV2ControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  userconfigurationsV2ControllerDelete$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkUserconfigurationsV2Service.UserconfigurationsV2ControllerDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userconfigurationsV2ControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userconfigurationsV2ControllerDelete(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<void> {
    return this.userconfigurationsV2ControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
